import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Breadcrumb from './components/Breadcrumb';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/Home';
import DebtManagement from './pages/DebtManagement';
import PIX from './pages/PIX';
import Investments from './pages/Investments';
import Savings from './pages/Savings';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Planning from './pages/Planning';
import TesouroDireto from './pages/TesouroDireto';
import FIIs from './pages/FIIs';
import Cryptocurrencies from './pages/Cryptocurrencies';
import DigitalBanks from './pages/DigitalBanks';
import CreditCard from './pages/CreditCard';
import RealEstate from './pages/RealEstate';
import RentVsBuy from './pages/RentVsBuy';
import IncomeTax from './pages/IncomeTax';
import TaxExemptions from './pages/TaxExemptions';
import Calculators from './pages/Calculators';
import Spreadsheets from './pages/Spreadsheets';
import Market from './pages/Market';
import './App.css';

function App() {

  return (
    <ErrorBoundary>
      <Router>
        <ScrollToTop />
        <div className="App min-h-screen bg-gray-50">
          <Header />
          <Breadcrumb />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/calculadoras" element={<Calculators />} />
              <Route path="/planilhas" element={<Spreadsheets />} />
              <Route path="/mercado" element={<Market />} />
              {/* Add other routes gradually */}
              <Route path="/dividas" element={<DebtManagement />} />
              <Route path="/economia" element={<Savings />} />
              <Route path="/planejamento" element={<Planning />} />
              <Route path="/investimentos" element={<Investments />} />
              <Route path="/tesouro-direto" element={<TesouroDireto />} />
              <Route path="/fiis" element={<FIIs />} />
              <Route path="/criptomoedas" element={<Cryptocurrencies />} />
              <Route path="/bancos-digitais" element={<DigitalBanks />} />
              <Route path="/cartao-credito" element={<CreditCard />} />
              <Route path="/pix" element={<PIX />} />
              <Route path="/financiamento" element={<RealEstate />} />
              <Route path="/aluguel-vs-compra" element={<RentVsBuy />} />
              <Route path="/imposto-renda" element={<IncomeTax />} />
              <Route path="/isencoes" element={<TaxExemptions />} />
              <Route path="/calculadoras" element={<Calculators />} />
              <Route path="/planilhas" element={<Spreadsheets />} />
              <Route path="/mercado" element={<Market />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
